import React from 'react'
import ButtonProps from '../../interfaces/ButtonProps';

const LessBtn: React.FC<ButtonProps> = ({color, className, onClickFunc}) => {
  return (
    <button className={className} onClick={onClickFunc}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        /*
        width="40"
        height="40"
        */
        viewBox="0 0 1000 1000"
      >
        <desc>Created with Fabric.js 3.5.0</desc>
        <rect x="0" y="0" width="100%" height="100%" fill="none" />
        <g transform="matrix(36.5648 0 0 36.5648 499.9994 499.9994)" id="936105">
          <path
            style={{
              stroke: 'none',
              strokeWidth: 1,
              strokeDasharray: 'none',
              strokeLinecap: 'butt',
              strokeDashoffset: 0,
              strokeLinejoin: 'miter',
              strokeMiterlimit: 4,
              fill: color || '#000',
              fillRule: 'nonzero',
              opacity: 1,
            }}
            vectorEffect="non-scaling-stroke"
            transform="translate(-12.4312, -12.3952)"
            d="M 0.00000568368 12.4106 C -0.0064841 5.58276 5.54553 0.0170396 12.3809 0.0000388663 C 19.2398 -0.0169619 24.8478 5.54552 24.8624 12.3806 C 24.877 19.2028 19.2625 24.7977 12.4109 24.7904 C 5.56824 24.7831 0.00730501 19.2352 0.000815224 12.4098 L 0.00000568368 12.4106 Z M 23.0842 12.3847 C 23.0761 6.53075 18.2866 1.75597 12.4239 1.75678 C 6.53603 1.75678 1.75549 6.54613 1.76604 12.4341 C 1.77658 18.2799 6.57092 23.0377 12.4466 23.0336 C 18.3012 23.0296 23.0923 18.2337 23.0842 12.3847 Z"
            strokeLinecap="round"
          />
        </g>
        <g transform="matrix(65.0281 0 0 65.0281 500 500)" id="633566">
          <path
            style={{
              stroke: 'none',
              strokeWidth: 1,
              strokeDasharray: 'none',
              strokeLinecap: 'butt',
              strokeDashoffset: 0,
              strokeLinejoin: 'miter',
              strokeMiterlimit: 4,
              fill: color || '#000',
              fillRule: 'nonzero',
              opacity: 1,
            }}
            vectorEffect="non-scaling-stroke"
            transform="translate(-5.4348, -1.3961)"
            d="M 5.4502 0.501401 C 6.69137 0.501401 7.93173 0.497352 9.17291 0.503019 C 9.80728 0.505448 10.2299 0.877845 10.221 1.4073 C 10.2129 1.92542 9.81377 2.28567 9.20373 2.28729 C 6.68569 2.29377 4.16766 2.29377 1.65043 2.28729 C 1.01524 2.28567 0.655869 1.95537 0.648568 1.41054 C 0.640456 0.842225 1.01119 0.505448 1.67396 0.503019 C 2.93297 0.497352 4.19199 0.501401 5.45101 0.501401 H 5.4502 Z"
            strokeLinecap="round"
          />
        </g>
      </svg>
    </button>
  )
}

export default LessBtn;
